export default __webpack_public_path__ + "static/media/200928_DeskStandWithShelf.c81a3aaa.gltf";